var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:("chip " + _vm.confidenceClass),attrs:{"title":_vm.confidenceTitle}},[_vm._v(_vm._s(_vm.confidenceText))])])}
var staticRenderFns = []

export { render, staticRenderFns }